module.exports = __webpack_public_path__ + "img/ontario-rev.96494fc7.svg";